import React from "react";

type LazyComponent = () => Promise<{ default: React.ComponentType<any> }>;
type ComponentMap = Record<string, LazyComponent | 'redirect-404'>;

export const pagesMap: ComponentMap = {
  
    //---FEATURES---///
    DashboardPage: () => import('@/feature/dashboard/pages/DashboardPage'),
    Profile: () => import('@/feature/profile/pages/Profile'),
    Settings: () => import('@/feature/settings/pages/Settings'),
    IdCard: () => import('@/feature/idCard/pages/IdCardPage'),
    IdCardEdit: () => import('@/feature/idCard/pages/IdCardEditPage'),
    IdCardPreview: () => import('@/feature/idCard/pages/IdCardPreviewPage'),
    WebsiteList: () => import('@/feature/admin/webpage/pages/list/ListPage'),
    WebsiteCreate: () => import('@/feature/admin/webpage/pages/create/CreatePage'),

    //---AUTH---///
    SignInPage: () => import('@/feature/auth/pages/SignIn'),
    CreateAccountPage: () => import('@/feature/auth/pages/CreateAccount'),

    //---APP---///
    NotFound: () => import('./not-found'),
    LandingPage: () => import('./landing'),

    //---ADMIN---///
    AdminRoutesHelper: () => import('./backoffice/admin/RoutesHelperPage'),

    //---UTILS AND HELPERS---///
    ProtectedRoute: () => import('../routes/ProtectedRoute'),
    Redirect404: 'redirect-404'
};
